import { UserSettings } from '../models/UserSettings';
import { useUserSettingsQuery } from '../userSettingsApi';

export const useUserSettings = (): UserSettings => {
  const { data } = useUserSettingsQuery();

  return data!;
};
